module.exports = __webpack_public_path__ + "img/clarity_success-line.afbcdf23.svg";